export default __webpack_public_path__ + "assets/images/a59d11adb7135014c9a369df4e8a4d26.svg";